export default __webpack_public_path__ + "static/media/company8.fdf9d585.png";